import { useEffect } from "react";
import { useI18n } from "@/hooks/useI18n";
import { getLegalUrl, type LegalDocument } from "@/constants/legal-links";

/**
 * Manda il browser fuori dall'app. Serve per le rotte che un tempo erano pagine
 * interne e ora vivono sul sito: i link già in giro (email, segnalibri) devono
 * continuare a funzionare invece di finire sulla 404.
 */
export const ExternalRedirect = ({ to }: { to: string }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
};

/** Rimando ai documenti legali sul sito, nella lingua corrente dell'interfaccia. */
export const LegalRedirect = ({ doc }: { doc: LegalDocument }) => {
  const { language } = useI18n();
  return <ExternalRedirect to={getLegalUrl(doc, language)} />;
};
